let consumer;
export async function getConsumer() {
  return consumer || setConsumer(createConsumer().then(setConsumer));
}
export function setConsumer(newConsumer) {
  return consumer = newConsumer;
}
export async function createConsumer() {
  const _await$import = await import(
  /* webpackChunkName: "actioncable" */
  "@rails/actioncable/src"),
        createConsumer = _await$import.createConsumer;

  return createConsumer();
}
export async function subscribeTo(channel, mixin) {
  const _await$getConsumer = await getConsumer(),
        subscriptions = _await$getConsumer.subscriptions;

  return subscriptions.create(channel, mixin);
}